// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isFriday as fn } from "../isFriday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isFridayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isFridayWithOptions;
